// extracted by mini-css-extract-plugin
export default {"wrapper":"FlagImagePlaceholder_wrapper__j3wZg"};